import { congratulationsPopupResources } from '../../../core/gameConstants';
import { BaseCongratulationsPopup } from './BaseCongratulationsPopup';
import { gameConfig } from '../../../core/configs';

class CongratulationsDesktopPopup extends BaseCongratulationsPopup {
  constructor() {
    super();
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(congratulationsPopupResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  async onLoad() {
    return this.loadResource();
  }

  executeWeb({ root }) {
    return this.loadResource().then(() => {
      const container = this.getPopup({
        width: 1050,
        parentWidth: gameConfig.width,
        parentHeight: gameConfig.height,
        padding: gameConfig.width * .095,
        onClick: this.onClick(),
        scale: 1.4,
        percent: 18,
      });
      root.addChild(container);
    });
  }
}

export const congratulationsDesktopPopup = new CongratulationsDesktopPopup();
